import { GET_NOTES_FAIL, GET_NOTES_SUCCESS, GET_NOTES_REQUEST } from "../constants/notes";


const initialState = {
    loading: false,
    success: false,
    error: null,
    data: null
}

const getNotes = (state = initialState, action) => {
    switch (action.type) {
        case GET_NOTES_REQUEST:
            return { ...state, loading: true };
        case GET_NOTES_SUCCESS:
            return { ...state, loading: false, success: true, data: action.payload };
        case GET_NOTES_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
}


export { getNotes }
